export const insights = [
  {
    id: "beyond-poc",
    tag: "AI Strategy",
    title: "Beyond the PoC: Why 74% of AI projects never see production",
    excerpt:
      "Most AI initiatives stall between demo and deployment. We break down the four organisational failure modes and how to design pilots that ship.",
    date: "Nov 2025",
    readTime: "6 min read",
  },
  {
    id: "digital-thread",
    tag: "Manufacturing",
    title: "The digital thread is the real Industry 4.0",
    excerpt:
      "Sensors are cheap. Data fabric is not. A pragmatic playbook for connecting BOM, MES and QMS without a decade-long re-platforming project.",
    date: "Oct 2025",
    readTime: "9 min read",
  },
  {
    id: "regulatory-copilots",
    tag: "Pharma",
    title: "Regulatory copilots that reviewers actually trust",
    excerpt:
      "Grounding, citation and provenance — three non-negotiables for deploying LLMs inside a regulated pharma organisation.",
    date: "Oct 2025",
    readTime: "7 min read",
  },
  {
    id: "vernacular-ai",
    tag: "Agritech",
    title: "Vernacular voice AI for smallholder farmers",
    excerpt:
      "Why WhatsApp-first, voice-first design wins over apps in Bharat — and how we route escalations to human agronomists.",
    date: "Sep 2025",
    readTime: "5 min read",
  },
];
